export default __webpack_public_path__ + "static/media/DELIRIUM.9ae7afb8.png";